const MobileAppliedChips = ({ chips = [] }) => {
    if (!chips.length) return null;

    return (
        <div className="discovery-mobile-applied-chips" aria-label="Applied filters and sorting">
            {chips.map(({ key, label, icon, onOpen, onRemove, removeLabel }) => (
                <div className="discovery-mobile-applied-chip" key={key}>
                    {onOpen ? (
                        <button type="button" className="discovery-mobile-applied-chip__label" onClick={onOpen}>
                            <span>{label}</span>
                            {icon}
                        </button>
                    ) : (
                        <span className="discovery-mobile-applied-chip__label">
                            <span>{label}</span>
                            {icon}
                        </span>
                    )}
                    <button
                        type="button"
                        className="discovery-mobile-applied-chip__remove"
                        onClick={onRemove}
                        aria-label={removeLabel || `Remove ${label}`}
                    >
                        &times;
                    </button>
                </div>
            ))}
        </div>
    );
};

export default MobileAppliedChips;
